/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Invite_Codes_Invalid_InputInputs */

const en_admin_invite_codes_invalid_input = /** @type {(inputs: Admin_Invite_Codes_Invalid_InputInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please check your input`)
};

const zh_admin_invite_codes_invalid_input = /** @type {(inputs: Admin_Invite_Codes_Invalid_InputInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请检查输入`)
};

/**
* | output |
* | --- |
* | "Please check your input" |
*
* @param {Admin_Invite_Codes_Invalid_InputInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_invite_codes_invalid_input = /** @type {((inputs?: Admin_Invite_Codes_Invalid_InputInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Invite_Codes_Invalid_InputInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_invite_codes_invalid_input(inputs)
	return zh_admin_invite_codes_invalid_input(inputs)
});
export { admin_invite_codes_invalid_input as "admin.invite_codes.invalid_input" }